<template>
  <q-page class="container" padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">
        Relatório de Movimentações
      </p>
    </div>
    <div class="row col-lg-12 col-md-10 q-gutter-sm q-mb-xl q-mt-sm">
      <div
        class="col-lg-2 col-md-2 col-sm-12 col-xs-12 text-brand-5 text-weight-bold dimensionar"
      >
        Unidade

        <lista-unidades-select
          v-model="recebeUnidade.unidade"
        ></lista-unidades-select>
      </div>

      <div
        class="col-lg-2 col-md-2 col-sm-12 col-xs-12 text-brand-5 text-weight-bold"
      >
        Nome do Colaborador
        <q-input dense outlined v-model="filtros.funcionario" type="text" />
      </div>
      <div
        class="col-lg-2 col-md-2 col-sm-12 col-xs-12 text-brand-5 text-weight-bold"
      >
        Data Retirada (Inicial)
        <q-input
          dense
          outlined
          placeholder="DD/MM/AAAA"
          v-model="filtros.dataInicialRetirada"
          mask="##/##/####"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                  v-model="filtros.dataInicialRetirada"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <p class="row aling text-brand-5 text-bold dimensionarTexto">Até</p>
      <div
        class="col-lg-2 col-md-2 col-sm-12 col-xs-12 text-brand-5 text-weight-bold"
      >
        Data Retirada (Final)
        <q-input
          dense
          outlined
          placeholder="DD/MM/AAAA"
          v-model="filtros.dataFinalRetirada"
          mask="##/##/####"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                  v-model="filtros.dataFinalRetirada"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div class="text-brand-5 text-bold dimensionar">
        <p style="margin: 0">O Checklist foi feito?</p>
        <q-radio v-model="checklist.resposta" val="true" label="Sim"></q-radio>
        <q-radio v-model="checklist.resposta" val="false" label="Não"></q-radio>
      </div>

      <div class="col-lg-1 col-md-2 col-sm-12 col-xs-12">
        <p></p>
        <q-btn
          class="q-mt-sm full-width"
          color="primary"
          label="Filtrar"
          type="submit"
          icon="filter_alt"
          no-caps
          @click.prevent="filtrar(false)"
        />
      </div>
      <div class="col-xl-2 col-lg-2 col-md-3 col-sm-12 col-xs-12">
        <p></p>
        <q-btn
          class="full-width q-mt-sm"
          label="Todas Unidades"
          type="submit"
          no-caps
          :disable="disable"
          :icon="todasUnidades ? 'close' : 'check_circle_outline'"
          :color="!todasUnidades ? 'primary' : 'negative'"
          @click="todasUnidades = !todasUnidades"
        />
      </div>
    </div>
    <p class="text-h6 text-brand-5 text-weight-medium">Itens</p>
    <div class="q-mt-md">
      <q-table
        table-header-class="bg-accent text-weight-bold"
        style="max-height: 50vh"
        class="q-mt-sm table_header tabela-tamanho-fixo"
        :rows="movimentacoes"
        dense
        :columns="columns"
        :rows-per-page-options="[0]"
        :loading="loading"
        :hide-bottom="hideBottom"
        :no-data-label="semDados ? 'Movimentações não encontradas' : ''"
        flat
      >
        <template v-slot:body="props">
          <q-tr :props="props">
            <q-td
              class="text-left text-brand-5 text-weight-bold"
              key="unidade"
              :props="props"
              >{{ props.row.unidade }}</q-td
            >
            <q-td
              class="text-left text-brand-5 text-weight-bold"
              key="ferramenta"
              :props="props"
              >{{ props.row.ferramenta }}</q-td
            >
            <q-td
              class="text-left text-brand-5 text-weight-bold"
              key="descricao"
              :props="props"
              >{{ props.row.descricao }}</q-td
            >
            <q-td
              class="text-left text-brand-5 text-weight-bold"
              key="preco"
              :props="props"
              >{{ "R$" + " " + props.row.preco }}</q-td
            >
            <q-td
              class="text-left text-brand-5 text-weight-bold"
              key="patrimonio"
              :props="props"
              >{{ props.row.patrimonio }}</q-td
            >
            <q-td
              class="text-left text-brand-5 text-weight-bold"
              key="permanencia"
              :props="props"
            >
              <div>
                {{
                  props.row.permanencia != null
                    ? `${props.row.permanencia} min`
                    : 0
                }}
              </div>
            </q-td>

            <q-td
              class="text-left text-brand-5 text-weight-bold"
              key="funcionario"
              :props="props"
            >
              <div>{{ props.row.funcionario }}</div>
            </q-td>

            <q-td
              class="text-left text-brand-5 text-weight-bold"
              key="dataInicialRetirada"
              :props="props"
            >
              <div>
                {{
                  props.row.dataInicialRetirada
                    ?.split(" ")[0]
                    .split("-")
                    .reverse()
                    .join("/")
                }}
                <p style="margin: 0 0 0 9px">
                  {{ props.row.dataInicialRetirada?.split(" ")[1] }}
                </p>
              </div>
            </q-td>

            <q-td
              class="text-left text-brand-5 text-weight-bold"
              key="dataInicialDevolucao"
              :props="props"
            >
              <div>
                {{
                  props.row.dataInicialDevolucao
                    ?.split(" ")[0]
                    .split("-")
                    .reverse()
                    .join("/")
                }}
                <p style="margin: 0 0 0 9px">
                  {{ props.row.dataInicialDevolucao?.split(" ")[1] }}
                </p>
              </div>
            </q-td>
          </q-tr>
        </template>
        <template v-slot:top-right>
          <div class="row">
            <q-input
              class="q-mr-md"
              rounded
              outlined
              dense
              debounce="300"
              v-model="filter"
              type="text"
              placeholder="Pesquisar"
            >
              <template v-slot:append>
                <q-icon name="search" />
              </template>
            </q-input>
            <q-btn
              class="q-mr-sm"
              color="secondary"
              icon="file_upload"
              label="Exportar Todas Unidades"
              type="submit"
              no-caps
              @click="exportar2"
            />
            <q-btn
              color="secondary"
              icon="file_upload"
              label="Exportar"
              type="submit"
              no-caps
              @click="exportar()"
            />
          </div>
        </template>
      </q-table>
    </div>
  </q-page>
</template>

<script>
import { ref, watch, onMounted } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";

export default {
  components: { ListaUnidadesSelect },
  name: "RelatórioMovimentacao",

  setup() {
    const store = useStore();
    const $q = useQuasar();
    let loading = ref(false);
    let semDados = ref(false);
    let hideBottom = ref(true);
    let recebeUnidade = ref({
      unidade: store.state.org.unidadeData.nome,
      id: store.state.org.unidadeData.id,
    });

    const filtros = ref({
      funcionario: "",
      checklist: "",
      dataInicialRetirada: "",
      dataFinalRetirada: "",
      dataInicialDevolucao: "",
      dataFinalDevolucao: "",
    });

    const checklist = ref(["TODOS", "SOMENTE NÃO", "SOMENTE SIM"]);

    const movimentacoes = ref([]);

    const columns = [
      {
        name: "unidade",
        label: "Unidade",
        field: "unidade",
        align: "left",
        sortable: true,
      },
      {
        name: "ferramenta",
        label: "Código",
        field: "ferramenta",
        align: "left",
        sortable: true,
      },
      {
        name: "descricao",
        label: "Descrição",
        field: "descricao",
        align: "left",
        sortable: true,
      },
      {
        name: "preco",
        label: "Preço",
        field: "preco",
        align: "left",
        sortable: true,
      },
      {
        name: "patrimonio",
        label: "Patrimônio",
        field: "patrimonio",
        align: "left",
        sortable: false,
      },
      {
        name: "permanencia",
        label: "Permanência",
        field: "permanencia",
        align: "left",
        sortable: false,
      },
      {
        name: "funcionario",
        label: "Colaborador",
        field: "funcionario",
        align: "left",
        sortable: false,
      },
      {
        name: "dataInicialRetirada",
        label: "Data Retirada",
        field: "dataInicialRetirada",
        align: "left",
        sortable: false,
      },

      {
        name: "dataInicialDevolucao",
        label: "Data Devolução",
        field: "dataInicialDevolucao",
        align: "left",
      },
    ];
    let todasUnidades = ref(false);
    const filter = ref("");
    let disable = ref(false);

    let filtrar = async () => {
      try {
        loading.value = true;
        hideBottom.value = true;
        let resposta = await store.dispatch("fer/relatorioMovimentacoes", {
          unidadeId: todasUnidades.value ? "" : recebeUnidade.value.id,
          funcionario: filtros.value.funcionario,
          dataInicialRetirada: filtros.value.dataInicialRetirada,
          dataFinalRetirada: filtros.value.dataFinalRetirada,
          dataInicialDevolucao: filtros.value.dataInicialDevolucao,
          dataFinalDevolucao: filtros.value.dataFinalDevolucao,
          ferramenta: filter.value,
        });

        movimentacoes.value = resposta.movimentacoes;
        loading.value = false;

        if (movimentacoes.value == "") {
          semDados.value = true;
          hideBottom.value = false;
        }
      } catch (error) {
        console.log(error);
      }
    };

    let exportar = async () => {
      await store.dispatch("fer/exportarRelatorioMovimentacoes", {
        unidadeId: recebeUnidade.value.id,
        funcionario: filtros.value.funcionario,
        dataInicialRetirada: filtros.value.dataInicialRetirada,
        dataFinalRetirada: filtros.value.dataFinalRetirada,
        dataInicialDevolucao: filtros.value.dataInicialDevolucao,
        dataFinalDevolucao: filtros.value.dataFinalDevolucao,
      });
      mensagem(
        "Seu relatório de MOVIMENTAÇÕES está sendo processado, você receberá um link pra download no seu email assim que ele estiver pronto!"
      );
    };

    let exportar2 = async () => {
      await store.dispatch("fer/exportarRelatorioMovimentacoes", {
        unidadeId: "",
        funcionario: filtros.value.funcionario,
        dataInicialRetirada: filtros.value.dataInicialRetirada,
        dataFinalRetirada: filtros.value.dataFinalRetirada,
        dataInicialDevolucao: filtros.value.dataInicialDevolucao,
        dataFinalDevolucao: filtros.value.dataFinalDevolucao,
      });
      mensagem(
        "Seu relatório de MOVIMENTAÇÕES está sendo processado, você receberá um link pra download no seu email assim que ele estiver pronto!"
      );
    };

    let mensagem = (mensagem) => {
      $q.notify({
        message: mensagem,
        color: "positive",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    };

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        recebeUnidade.value.unidade = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        recebeUnidade.value.unidade = store.state.org.unidadeData;
        recebeUnidade.value.id = store.state.org.unidadeData.id;
        filtrar();
      }
    );

    watch(
      () => todasUnidades.value,
      () => {
        filtrar();
      }
    );

    watch(
      () => filter.value,
      () => {
        filtrar();
      }
    );

    onMounted(filtrar);

    return {
      filter,
      filtros,
      columns,
      movimentacoes,
      filtrar,
      checklist,
      exportar,
      loading,
      exportar2,
      semDados,
      hideBottom,
      disable,
      myLocale: {
        /* starting with Sunday */
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      recebeUnidade,
      todasUnidades,
    };
  },
};
</script>

<style lang="sass">
.dimensionarTexto
  margin-top: 35px

ul
  list-style: none
  margin: 0
  padding: 0

@media (max-width: 900px)
  .dimensionarTexto
    display: none

@media (max-width: 1198px)
  .dimensionar
    margin-top: 29px

  .dimensionarTexto
    margin-top: 55px
.table_header

  thead tr th
    position: sticky
    z-index: 1

  thead tr:last-child th

    top: 48px
  thead tr:first-child th
    top: 0

  tbody tr td
    white-space: pre-wrap

.elipse
  width: 12px
  height: 12px
  border-radius: 50%
</style>
